module.exports = __webpack_public_path__ + "img/drone-stuwcomplex-hagestein.e74e2aaa.jpg";